import React, { memo } from 'react';
import ActionTwoHopProgressTable from '../ActionTwoHopProgressTable/ActionTwoHopProgressTable';
import ActionTwoHopRecAlignBeamsTable from '../ActionTwoHopRecAlignBeamsTable/ActionTwoHopRecAlignBeamsTable';
import HeatmapViewableImagesContainer from 'components/features/HeatmapViewAndExportModal/HeatmapViewableImagesContainer/HeatmapViewableImagesContainer';
import '../ActionTwoHopProgressViewModal.css';

const ActionTwoHopModalContentContainer = (props) => {
  return (
    <div
      id="ActionTwoHopProgressViewModal_Content_Container"
      className="ActionTwoHopProgressViewModal_Content_Container"
    >
      <div
        id="ActionTwoHopProgressViewModal_Content_Left_Container"
        className="ActionTwoHopProgressViewModal_Content_Left_Container"
      >
        <div
          id="ActionTwoHopProgressViewModal_ProgressTable_Container"
          className="ActionTwoHopProgressViewModal_ProgressTable_Container"
        >
          <ActionTwoHopProgressTable
            donorDevice={props.action?.input?.pivot1DU ?? props.action?.input?.du1}
            donorDevice2={props.action?.input?.pivot2DU ?? props.action?.input?.du2}
            action={props.action}
            alignmentId={props.action?.commissioningId}
            isGetTwoHopAlignmentCalled={props.isGetTwoHopAlignmentCalled}
          />
        </div>
        <div
          id="ActionTwoHopProgressViewModal_RecAlignBeamsTable_Container"
          className="ActionTwoHopProgressViewModal_RecAlignBeamsTable_Container"
        >
          <div
            id="ActionTwoHopProgressViewModal_RecAlignBeamsTable_Header"
            className="ActionTwoHopProgressViewModal_RecAlignBeamsTable_Header"
          >
            Notepad for Alignment Beams
          </div>
          <div
            id="ActionTwoHopProgressViewModal_RecAlignBeamsTable_Description"
            className="ActionTwoHopProgressViewModal_RecAlignBeamsTable_Description"
          >
            The values entered here are for user reference only.
          </div>
          <ActionTwoHopRecAlignBeamsTable
            donorDevice={props.action?.input?.pivot1DU ?? props.action?.input?.du1}
            donorDevice2={props.action?.input?.pivot2DU ?? props.action?.input?.du2}
            action={props.action}
            alignmentId={props.action?.commissioningId}
            isGetTwoHopRecBeamInfoCalled={props.isGetTwoHopRecBeamInfoCalled}
            setIsGetTwoHopRecBeamInfoCalled={props.setIsGetTwoHopRecBeamInfoCalled}
            setPostTwoHopRecBeamInfoError={props.setPostTwoHopRecBeamInfoError}
          />
        </div>
      </div>

      <div
        id="ActionTwoHopProgressViewModal_Content_Right_Container"
        className="ActionTwoHopProgressViewModal_Content_Right_Container"
      >
        <HeatmapViewableImagesContainer
          donorDevice={props.action?.input?.pivot1DU ?? props.action?.input?.du1}
          donorDevice2={props.action?.input?.pivot2DU ?? props.action?.input?.du2}
          alignmentId={props.action?.commissioningId}
          action={props.action}
          setIsCollectingFiles={props.setIsCollectingFiles}
        />
      </div>
    </div>
  );
};

export default memo(ActionTwoHopModalContentContainer);
